
import {
    ADD_ORGANIZATION_PACKAGE_FORM_NAME,
    organizationPackageMapping_getRoutePathStringForForNavigationContainer,
    hasGenericOrganization
} from "./shared";

// framework
import React from "react";
import {connect} from "react-redux";
import {
    compose,
    withHandlers,
    lifecycle
} from "recompose";

// libraries
import {map, isEmpty, find, forEach, sortBy} from "lodash";

// graphical elements
import { Button } from "react-md";
import {reduxForm, Field, FieldArray} from "redux-form";
import * as Validation from "../../../components/form/Validation";
import SelectField from "../../../components/form/SelectField";
import {setDialog} from "../../../actions/dialogActions";
import {InfoBox, InfoBox_Field, InfoBox_TextField, TouchCheckbox} from "../../../AtollonTheme/ReactElements";
import Header from "../../../components/ContainerHeader";

// redux actions
import {setActiveForm} from "../../../actions/appActions";
import {
    getPerson,
    getOrganizationUserDetail,
    setOrganizationUserDetail,
    getOrganizationUsers,
    getOrganizationUsersAdmin,
    getOrganizationUsersOwner,
    getOrganizationUsersUser,
    getUserOrganizations,
    getServerCategories,
    getOrganizationsWithoutRelationRole,
    getPackages
} from "../../../actions/resourceActions";
import {} from "../../../actions/requestActions";
import {
    addOrganizationPackageMapping,
    getOrganizationPackageMapping,
    getOrganizationPackageMapping_forOrg,
    getOrganizationPackageMapping_forMyOrg
} from "../../../actions/OrganizationPackageMappingActions";

import TextField from "../../../components/form/TextField";

// my libs
import * as workInProgress from "../../messages/UserMessages";
import Translate from "../../Translation";
import {xml_utilities} from "../../utilities/xml_utilities";
import {array_utilities} from "../../utilities/array_utilities";
import {XMLEditor} from "../../utilities/XmlEditor";
import {DebugElement} from "../../debug";
import {
    getAvailablePackageListForAtollonInstance
} from "../../../actions/organizationActions";


export const GENERIC_ORGANIZATION_IDENTIFIER__FORM_VALUE = '***generic organization***'; // M: redux form does not allow '' in field value

let getOrganizationsForForm = ( state ) =>
{
    let { resource: { organizations }} = state;
    let menuItems = [];
    let sorted = null;
    if( !isEmpty( organizations ))
    {
        let organizationItems = organizations.item;
        sorted = array_utilities.array_of_structs_locale_sort_by_array_of_field_names( organizationItems, ['name'] );
    }

    menuItems.push({
        label: 'Viditelný pro všechny organizace (generic)',
        value: GENERIC_ORGANIZATION_IDENTIFIER__FORM_VALUE
    });

    forEach( sorted, item => {
        const nonNullName = item.name; // Warning: Failed prop type: The prop `primaryText` is marked as required in `ListItem`, but its value is `null`.
        if( nonNullName )
        {
            menuItems.push({
                label: item.name,
                value: item.identifier
            });
        }
    });
    console.log( "QQQ", {organizations, sorted, menuItems});
    return menuItems;

};

let getInstacesForForm = ( userOrganizationsAll ) =>
{
    let menuItems = [];
    let sortedInstances = array_utilities.array_of_structs_locale_sort_by_array_of_field_names( userOrganizationsAll, ['name'] );

    forEach( sortedInstances, item => {
        menuItems.push({
            label: item.name,
            value: item.id
        });
    });

    console.log( "QQQ", {userOrganizationsAll, sortedInstances, menuItems});

    return menuItems;
};

let getServerCategoryForForm = ( state ) =>
{
        let menuItems = [];
        let { resource: { serverCategories }} = state;
        forEach( serverCategories, item => {
            menuItems.push({
                label: item.name + ' (' + item.shortcut + ')',
                value: item.id
            });
        });
        console.log( "SSS", {serverCategories, menuItems});

        return menuItems;
};

let getPackagesForForm = ( state ) =>
{
    let { resource: { packages, productsByOrganization }} = state;
    let menuItems = [];

    if ( packages )
    {
        forEach( sortBy( packages, ['description','name'] ), item => {
            menuItems.push({
                label: item.description + " (" + item.name + ")",
                value: item.name
            });
        });
    }

    // if ( productsByOrganization && productsByOrganization.default )
    // {
    //     forEach( productsByOrganization.default, item => {
    //         menuItems.push({
    //             label: item.description + " (" + item.name + ")",
    //             value: item.name
    //         });
    //     });
    // }

    console.log( "SSS", {packages, productsByOrganization, menuItems });
    return menuItems;
};

const OrganizationPackageMapping_Add_and_Edit_AsReact = ( reactStateAndProps ) => {

    let {
        state: {
            app: {
                form: {
                    activeForm
                }
            },
            resource: {
                person,
                organizationUserDetails,
                organizationUsers,
                organizationUsersAdmin,
                organizationUsersOwner,
                organizationUsersUser,
                productsByOrganization,
                userOrganizationsAll,
                serverCategories,
                packages
            }
        },
        location,
        setActiveForm,
        initialValues,
        commonTitle,
        instanceUser,
        organizationPackageMapping_id,
        handleSubmit,
        history,
    } = reactStateAndProps;


    console.log( 'UUU', {reactStateAndProps,initialValues});

    let serverCategory_menuItems = getServerCategoryForForm( reactStateAndProps.state );
    let instanceId_menuItems  = getInstacesForForm( userOrganizationsAll );
    let organizationId_menuItems  = getOrganizationsForForm( reactStateAndProps.state );
    let packageId_menuItems  = getPackagesForForm( reactStateAndProps.state );

    let isAdding = activeForm === ADD_ORGANIZATION_PACKAGE_FORM_NAME;
    let isEditing = organizationPackageMapping_id;



    if( isAdding || isEditing )
    {
        return(
            <div>

                    <Header title={commonTitle} />

                    <InfoBox>

                            <h1>{isEditing? 'Úprava balíčku':'Přidání balíčku pro organizaci'}</h1>

                            <form  onSubmit={handleSubmit} className="">

                                    {isEditing? (
                                        <InfoBox_TextField
                                            name={"id"}
                                            value={organizationPackageMapping_id}
                                        /> )
                                    : null
                                    }

                                    <Field
                                        component={TextField}
                                        label={Translate("productDescription","productDescription")}
                                        name={"productDescription"}
                                        validate={[Validation.required]}
                                    />

                                    <Field
                                        component={TextField}
                                        label={Translate("productName","productName")}
                                        name={"productName"}
                                        validate={[Validation.required]}
                                    />

                                    <Field
                                        component={SelectField}
                                        label={Translate("Organizace","Organizace")}
                                        name={"organizationIdentifier"}
                                        menuItems={organizationId_menuItems}
                                        validate={[Validation.required]}
                                    />

                                    <Field
                                        component={SelectField}
                                        label={Translate("Kategorie serveru","Kategorie serveru")}
                                        name={"serverCategory.id"}
                                        menuItems={serverCategory_menuItems}
                                        validate={[Validation.required]}
                                    />

                                    <div style={{padding:'28px 0'}}>
                                        <div style={{color: '#0792FF', fontSize: '14px', padding: '0 0 8px 0' }}>dedicated:</div>
                                        <Field
                                            component={"input"}
                                            label={"Dedicated?"}
                                            type={"checkbox"}
                                            name={"dedicated"}
                                        />
                                    </div>

                                    <Field
                                        component={SelectField}
                                        label={Translate("Balíček","Balíček")}
                                        name={"packageId"}
                                        menuItems={packageId_menuItems}
                                        validate={[Validation.required]}
                                    />
                                    {/*
                                    <Field
                                        component={SelectField}
                                        label={Translate("Instance","Instance")}
                                        name={"instanceId"}
                                        menuItems={instanceId_menuItems}
                                        validate={[Validation.required]}
                                    />
                                    */}


                                    {/*
                                    //                 <InfoBox_TextField
                                    //                     name={Translate("Uživatelské jméno", "Uživatelské jméno")}
                                    //                     value={instanceUser.userDetail_get_userName()}
                                    //                 />
                                    //

                                    //                 <InfoBox_TextField
                                    //                     name={Translate("Jméno", "Jméno")}
                                    //                     value={instanceUser.userDetail_get_contactName()}
                                    //                 />
                                    //
                                    //
                                    //                 {/*
                                    //
                                    //                 <FieldArray
                                    //                     component={SelectField}
                                    //                     label={Translate("Skupiny", "Skupiny")}
                                    //                     name={"group"}
                                    //                     menuItems={map(userDetail_get_GROUP(), groupInfo => {
                                    //                             return (
                                    //                                 {
                                    //                                     label: userDetail_get_GROUP_name( groupInfo ),
                                    //                                     value: userDetail_get_GROUP_id( groupInfo )
                                    //                                 }
                                    //                             );
                                    //                         }
                                    //                     )}
                                    //                 />
                                    //
                                    //                 <Field
                                    //                     component={SelectField}
                                    //                     label={Translate("Role", "Role")}
                                    //                     name={"role"}
                                    //                     menuItems={map(userDetail_get_ROLE(), roleInfo => {
                                    //                             return (
                                    //                                 {
                                    //                                     label: userDetail_get_ROLE_name( roleInfo ),
                                    //                                     value: userDetail_get_ROLE_id( roleInfo )
                                    //                                 }
                                    //                             );
                                    //                         }
                                    //                     )}
                                    //                 />
                                    //
                                    //                 <Field
                                    //                     component={TextField}
                                    //                     label={Translate("Profil uživatele","Profil uživatele")}
                                    //                     name={"profileName"}
                                    //                     value={userDetail_get_profileName()}
                                    //                 />
                                    //
                                    //                 <Field
                                    //                     component={TextField}
                                    //                     label={Translate("Je admin?","Je admin?")}
                                    //                     name={"canSeeAdminTree"}
                                    //                     value={yesNo(userDetail_get_canSeeAdminTree())}
                                    //                 />
                                    //
                                    //                 <Field
                                    //                     component={SelectField}
                                    //                     label={Translate("Typ uživatele","Typ uživatele")}
                                    //                     name={"isPublicUser"}
                                    //                     menuItems={[
                                    //                         {label:Translate("Externí uživatel","Externí uživatel"), value:"false"},
                                    //                         {label:Translate("Power user","Power user"), value:"true"}
                                    //                     ]}
                                    //                 />
                                    //
                                    //
                                    */}
                                    <br />
                                    <br />
                                    <br />

                                    <Button
                                        raised
                                        className="btn touchButton-5"
                                        label="Zrušit editaci"
                                        onClick={() => {
                                            if( isEditing )
                                            {
                                                history.push( organizationPackageMapping_getRoutePathStringForForNavigationContainer() );
                                            }
                                            else
                                            {
                                                setActiveForm(null);
                                            }
                                        }}
                                    />
                                    <div className="touchButtons-spaceBetween" />

                                    <Button
                                        type="submit"
                                        primary
                                        raised
                                        className="btn btn-primary touchButton-6"
                                        label={isAdding? "Přidat": "Uložit"}
                                    />

                            </form>
                </InfoBox>
            </div>
        );
    }
    else
    {
        return (
            <DebugElement text={"InstanceUserDetail -- PASS"}/>
        );
    }
};


/**
 *
 *
 * Redux has this nonsense to wrap around React component.
 * It is intended to pass state from top components
 *
 *
 *
 */

export const OrganizationPackageMapping_Add_and_Edit_AsRedux = (compose(
    connect((state) => {
        return {
            state: state
        };
    }, {
        getPerson,
        getOrganizationUserDetail,
        getOrganizationUsers,
        getOrganizationUsersAdmin,
        getOrganizationUsersOwner,
        getOrganizationUsersUser,
        setDialog,
        setActiveForm,
        setOrganizationUserDetail,
        getAvailablePackageListForAtollonInstance,
        addOrganizationPackageMapping,
        getOrganizationPackageMapping,
        getOrganizationPackageMapping_forMyOrg,
        getUserOrganizations,
        getServerCategories,
        getOrganizationsWithoutRelationRole,
        getPackages
}),
    withHandlers({
        onSubmit: () => async (formData, dispatch, props) => {

            let {addOrganizationPackageMapping, getOrganizationPackageMapping, getOrganizationPackageMapping_forMyOrg, state} = props;

            let addParameters = {};
            // addParameters.id =
            // addParameters.organizationId =
            // addParameters.packageId =

            let isEditing = formData.id;
            if( isEditing )
            {
                // isEditing
                addParameters.id = formData.id;
            }
            else
            {
                // isAdding
            }

            addParameters.productDescription = formData.productDescription;
            addParameters.productName = formData.productName;

            if( formData.organizationIdentifier === GENERIC_ORGANIZATION_IDENTIFIER__FORM_VALUE )
            {
                // don't add anything
            }
            else
            {
                addParameters.organizationIdentifier = formData.organizationIdentifier;
            }
            addParameters.packageId = formData.packageId;
            addParameters.serverCategory = {};
            addParameters.serverCategory.id = formData.serverCategory.id;
            // serverCategoryInfo = getServerCategoryInformationFromState( state );
            // addParameters.serverCategory.name = serverCategoryInfo.serverCategory;
            // addParameters.serverCategory.shortcut = serverCategoryInfo.serverCategory;
            addParameters.dedicated = formData.dedicated;

            let ok = await addOrganizationPackageMapping( addParameters );
            if( ok )
            {
                await getOrganizationPackageMapping();
                await getOrganizationPackageMapping_forMyOrg();
                if( isEditing )
                {
                    workInProgress.userMessage_ok("Vlastní balíček upraven");
                }
                else
                {
                    workInProgress.userMessage_ok("Vlastní balíček přidán");
                }
            }

            // let { location, getOrganizationUserDetail, setOrganizationUserDetail, organizationUserDetails } = props;
            //
            // console.log( '%csubmit', 'background:red;color:#fff;', formData, arguments );
            //
            // //
            // // get user as xml string
            // //
            // let errorMessage =  '';
            // let organizationId = getOrganizationIdFromLocation( location );
            // let userId = getUserDetailIdFromLocation(location);
            // if( organizationUserDetails && organizationUserDetails[userId] )
            // {
            //     let userXMLAsString;
            //     userXMLAsString = organizationUserDetails[userId];
            //     if( userXMLAsString )
            //     {
            //         console.log('InstanceUserDetail parsed information', {organizationId, userId});
            //
            //         //
            //         // edit all parameters in xml
            //         //
            //         let editor = new XMLEditor();
            //         if( editor.setXMLString( userXMLAsString ))
            //         {
            //             let allParametersAddedOk = true;
            //             if( ! editor.changeOrCreateElement( 'active', formData.active )){ allParametersAddedOk = false; }
            //             if( ! editor.changeOrCreateElement( 'forwardingEmail', formData.forwardingEmail )){ allParametersAddedOk = false; }
            //
            //             if( allParametersAddedOk )
            //             {
            //                 let editedXMLAsString = editor.getXML();
            //                 if( editedXMLAsString )
            //                 {
            //                     await setOrganizationUserDetail(organizationId, userId, editedXMLAsString );
            //                     await getOrganizationUserDetail(organizationId, userId);
            //                 }
            //                 else
            //                 {
            //                     errorMessage = 'Chyba při ukládání uživatele instance (5)';
            //                 }
            //             }
            //             else
            //             {
            //                 errorMessage = 'Chyba při ukládání uživatele instance (4)';
            //             }
            //         }
            //         else
            //         {
            //             errorMessage = 'Chyba při ukládání uživatele instance (3)';
            //         }
            //     }
            //     else
            //     {
            //         errorMessage = 'Chyba při ukládání uživatele instance (2)';
            //     }
            // }
            // else
            // {
            //     errorMessage = 'Chyba při ukládání uživatele instance (1)';
            // }
            //
            // if( errorMessage )
            // {
            //     workInProgress.userMessage_throwErrorToFieldNamed( 'Editace uživatele instance', errorMessage );
            // }
            //
            // // debugger;
            //
            // // return;
            // //
            // // const {hostId, serverId, createMyAtollonInstance, history, users} = props;
            // //
            // // let createInstanceParameters = {};
            // // createInstanceParameters.name = formData.name;
            // // createInstanceParameters.ident = formData.ident;
            // // if (!serverChoosesCategory) {
            // //     createInstanceParameters.serverCategory = formData.serverCategory;
            // // }
            // // createInstanceParameters.productName = formData.productName;
            // // createInstanceParameters.productLocale = formData.productLocale;
            // //
            // //
            // // function testingData() {
            // //     createInstanceParameters.name = "moje krásná  nová instance  organizace23";
            // //     createInstanceParameters.ident = "ident23";
            // //     createInstanceParameters.serverCategory = "rct-shared";
            // //     createInstanceParameters.productName = "productName23";
            // //     createInstanceParameters.productLocale = "en";
            // // }
            // //
            // // if (
            // //     await createMyAtollonInstance(createInstanceParameters)
            // // ) {
            // //     workInProgress.userMessage_ok("Instance založena");
            // //     // history.push(`/hosts/${hostId}/${serverId}`);
            // // } else {
            // //     workInProgress.userMessage_throwErrorToFieldNamed('billingContact', "Instance nebyla založena");
            // // }
        }
    }),
    lifecycle({
        componentWillMount()
        {
            let {
                getAvailablePackageListForAtollonInstance,
                getUserOrganizations,
                getOrganizationsWithoutRelationRole,
                getServerCategories,
                getPackages
            } = this.props;

            getPackages('default');
            getAvailablePackageListForAtollonInstance('default');
            getServerCategories();
            getOrganizationsWithoutRelationRole({ showAllForAdmin: true }); // organizations
            getUserOrganizations(''); // instances
        }
    }),
    reduxForm({
        form: ADD_ORGANIZATION_PACKAGE_FORM_NAME,
        enableReinitialize: true
    })
)(OrganizationPackageMapping_Add_and_Edit_AsReact));



// WEBPACK FOOTER //
// ./src/Atollon/pages/OrganizationPackageMapping/OrganizationPackageMapping_Add_and_Edit.js